import { Directive, ElementRef, inject, Input, OnChanges } from '@angular/core';
import { BehaviorSubject, combineLatest, map, of, Subscription, tap } from 'rxjs';
import { FeatureFlag } from './feature-flags';
import { FeatureFlagsFacadeService } from './feature-flags-facade.service';

@Directive({
  selector: '[ngFeatureFlag]',
  standalone: true,
})
export class FeatureFlagDirective implements OnChanges {
  @Input({ required: true, alias: 'ngFeatureFlag' }) featureFlagKey!: FeatureFlag;

  readonly elementRef = inject(ElementRef);
  readonly featureFlagsFacade = inject(FeatureFlagsFacadeService);

  private subscription?: Subscription;
  private featureFlagKeySubject = new BehaviorSubject<FeatureFlag>(this.featureFlagKey);
  private feauteFlagKey$ = combineLatest([of(this.featureFlagsFacade.featureFlags), this.featureFlagKeySubject])
    .pipe(
      map(([featureFlags, featureFlagKey]) => featureFlags()?.[featureFlagKey] ?? false),
      tap((hasPermission) => this.updateVisibility(hasPermission))
    );

  ngOnInit(): void {
    this.subscription = this.feauteFlagKey$.subscribe();
  }

  ngOnChanges(): void {
    this.featureFlagKeySubject.next(this.featureFlagKey);
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  updateVisibility(enabled: boolean) {
    this.elementRef.nativeElement.style.display = enabled ? 'block' : 'none';
  }
}
